'use strict';

module.exports = (url = '') => {
  const urlParts = url.split('?');

  if (urlParts.length > 1) {
    urlParts[1] = `${urlParts[1]}&gift=true`;
    url = urlParts.join('?');
  }

  return url;
};
